function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgMessageCircleIcon = function SvgMessageCircleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M6.99967 12.8337C10.2213 12.8337 12.833 10.222 12.833 7.00033C12.833 3.77866 10.2213 1.16699 6.99967 1.16699C3.77801 1.16699 1.16634 3.77866 1.16634 7.00033C1.16634 7.93347 1.38545 8.81545 1.77503 9.5976C1.87856 9.80545 1.91301 10.043 1.85299 10.2674L1.50556 11.5659C1.35473 12.1296 1.87043 12.6453 2.43413 12.4944L3.73265 12.147C3.95697 12.087 4.19455 12.1214 4.4024 12.225C5.18455 12.6145 6.06653 12.8337 6.99967 12.8337Z",
    fill: "#868B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.35801 7.00007C6.35801 7.35445 6.64529 7.64173 6.99967 7.64173C7.35406 7.64173 7.64134 7.35445 7.64134 7.00007C7.64134 6.64568 7.35406 6.3584 6.99967 6.3584C6.64529 6.3584 6.35801 6.64568 6.35801 7.00007Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.79134 7.00007C3.79134 7.35445 4.07863 7.64173 4.43301 7.64173C4.78739 7.64173 5.07468 7.35445 5.07468 7.00007C5.07468 6.64568 4.78739 6.3584 4.43301 6.3584C4.07863 6.3584 3.79134 6.64568 3.79134 7.00007Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.92467 7.00007C8.92467 7.35445 9.21196 7.64173 9.56634 7.64173C9.92072 7.64173 10.208 7.35445 10.208 7.00007C10.208 6.64568 9.92072 6.3584 9.56634 6.3584C9.21196 6.3584 8.92467 6.64568 8.92467 7.00007Z",
    fill: "white"
  }));
};
export default SvgMessageCircleIcon;